import { usePersonalPropertyItemForm } from '../hooks';
import { PersonalPropertyItemForm } from './PersonalPropertyItemForm';
import {
  StandardPersonalPropertyItemFormFields,
  StandardPersonalPropertyItemFormFieldsProps,
} from '../../UI/components/StandardPersonalPropertyItemFormFields';

export type StandardPersonalPropertyItemFormVisibilityOptions =
  StandardPersonalPropertyItemFormFieldsProps['visibilityOptions'];

interface StandardPersonalPropertyItemFormProps {
  firmID: string;
  clientID: string;
  className?: string;
  visibilityOptions?: StandardPersonalPropertyItemFormVisibilityOptions;
  children?: React.ReactNode;
  usePersonalPropertyItemFormReturn: ReturnType<typeof usePersonalPropertyItemForm>;
}

export function StandardPersonalPropertyItemForm({
  children,
  clientID,
  firmID,
  className,
  visibilityOptions,
  usePersonalPropertyItemFormReturn,
}: StandardPersonalPropertyItemFormProps) {
  return (
    <PersonalPropertyItemForm
      className={className}
      usePersonalPropertyItemFormReturn={usePersonalPropertyItemFormReturn}
    >
      <StandardPersonalPropertyItemFormFields
        firmID={firmID}
        clientID={clientID}
        visibilityOptions={visibilityOptions}
      />
      {children}
    </PersonalPropertyItemForm>
  );
}
